import {
  CUSTOM_ELEMENTS_SCHEMA,
  Injectable,
  NgModule,
  inject
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import {
  CORE_I18N_FOLDER,
  CORE_PAGE_MODULE,
  CoreLoginGuard,
  CorePageModule,
  CorePageModuleIDs
} from '@bepatient/core';
import { Store } from '@ngrx/store';

@Injectable()
export class InstanceLoginGuard extends CoreLoginGuard {
  constructor() {
    const store = inject<Store<any>>(Store);
    const router = inject(Router);

    super(store, router);
  }
}

const pageModule: CorePageModule = {
  ID: CorePageModuleIDs.INSTANCE,
  routes: [
    {
      path: 'privacy',
      loadChildren: () =>
        import('./pages/privacy/privacy.module').then(m => m.PrivacyPageModule),
      canActivate: [InstanceLoginGuard]
    },
    {
      path: 'instance-access',
      loadChildren: () =>
        import('./pages/instance-access/instance-access.module').then(
          m => m.InstanceAccessPageModule
        ),
      canActivate: [InstanceLoginGuard]
    },
    {
      path: 'qr-code-scan',
      loadChildren: () =>
        import('./pages/qr-code-scan/qr-code-scan.module').then(
          m => m.QrCodeScanPageModule
        ),
      canActivate: [InstanceLoginGuard]
    }
  ]
};
@NgModule({
  imports: [RouterModule.forChild(pageModule.routes)],
  providers: [
    InstanceLoginGuard,
    { provide: CORE_PAGE_MODULE, useValue: pageModule, multi: true },
    { provide: CORE_I18N_FOLDER, useValue: './instance-dyn/i18n/', multi: true }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class InstanceDynModule {}
